import { EventEmitter, Component, forwardRef, ViewEncapsulation, Input, Output, Inject, PLATFORM_ID, ElementRef, ViewChild, HostListener, HostBinding, ContentChild, TemplateRef, Directive, Renderer2, Host, Pipe, NgModule } from '@angular/core';
import { isPlatformBrowser, CommonModule } from '@angular/common';
import { NG_VALUE_ACCESSOR, NgModel, NgForm, FormsModule } from '@angular/forms';
import { from } from 'linq/linq';
import { debounceTime, filter, distinctUntilChanged } from 'rxjs/operators';

/**
 * @fileoverview added by tsickle
 * Generated from: lib/component/select/select.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * 原名: techmore-select
 */
class SelectComponent {
    constructor() {
        /**
         * 是否顯示請選擇 (使用者)
         */
        this.isDefault = true;
        /**
         * 是否禁用
         */
        this.disabled = false;
        /**
         * 預設選擇標籤
         */
        this.defaultOptionLabel = '請選擇';
        this.selectChange = new EventEmitter();
        this.touch = (/**
         * @param {?} _
         * @return {?}
         */
        (_) => { });
        this.propagateChange = (/**
         * @param {?} _
         * @return {?}
         */
        (_) => { });
        // getSelectedLabel(): string {
        //   return from(this.options).where(option => option.value === this.selected).select(option => option.label).defaultIfEmpty('').first();
        // }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    set selected(value) {
        if (!this.isNoValue(value)) {
            this._selected = value;
        }
        else if (!this.isNoValue(this._selected)) {
            this._selected = undefined;
        }
        else {
            return;
        }
        this.propagateChange(this._selected);
    }
    /**
     * @return {?}
     */
    get selected() { return this._selected; }
    /**
     * @param {?} obj
     * @return {?}
     */
    writeValue(obj) {
        this.selected = obj;
    }
    /**
     * @param {?} fn
     * @return {?}
     */
    registerOnChange(fn) {
        this.propagateChange = fn;
    }
    /**
     * @param {?} fn
     * @return {?}
     */
    registerOnTouched(fn) {
        this.touch = fn;
    }
    /**
     * @param {?} isDisabled
     * @return {?}
     */
    setDisabledState(isDisabled) {
        this.disabled = isDisabled ? true : false;
    }
    /**
     * @param {?} value
     * @return {?}
     */
    onSelected(value) {
        if (this.isNoValue(value)) {
            value = undefined;
        }
        this.selected = value;
    }
    /**
     * @param {?} value
     * @return {?}
     */
    isNoValue(value) {
        /** @type {?} */
        const type = typeof value;
        if (type === 'undefined' || value === null || value === '') {
            return true;
        }
        return false;
    }
    /**
     * @param {?} value
     * @return {?}
     */
    onSelectChange(value) {
        this.selectChange.emit(value);
    }
}
SelectComponent.decorators = [
    { type: Component, args: [{
                selector: 'tm-select',
                template: "<select class=\"form-control\" [id]=\"name\" [(ngModel)]=\"selected\" (ngModelChange)=\"onSelectChange($event)\" (click)=\"touch('')\" [disabled]=\"disabled\" #selecter>\r\n  <option *ngIf=\"isDefault\" [ngValue]=\"undefined\">{{defaultOptionLabel}}</option>\r\n  <option *ngFor=\"let option of options\"\r\n          [ngValue]=\"option.value\">{{option.label}}</option>\r\n</select>\r\n",
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef((/**
                         * @return {?}
                         */
                        () => SelectComponent)),
                        multi: true
                    }
                ],
                encapsulation: ViewEncapsulation.None,
                styles: [""]
            }] }
];
SelectComponent.propDecorators = {
    isDefault: [{ type: Input }],
    disabled: [{ type: Input }],
    name: [{ type: Input }],
    defaultOptionLabel: [{ type: Input }],
    options: [{ type: Input }],
    selectChange: [{ type: Output }]
};
if (false) {
    /**
     * 是否顯示請選擇 (使用者)
     * @type {?}
     */
    SelectComponent.prototype.isDefault;
    /**
     * 是否禁用
     * @type {?}
     */
    SelectComponent.prototype.disabled;
    /**
     * 表單控制項名稱
     * @type {?}
     */
    SelectComponent.prototype.name;
    /**
     * 預設選擇標籤
     * @type {?}
     */
    SelectComponent.prototype.defaultOptionLabel;
    /**
     * 選項列表
     * @type {?}
     */
    SelectComponent.prototype.options;
    /** @type {?} */
    SelectComponent.prototype.selectChange;
    /**
     * 選中的標籤名
     * @type {?}
     */
    SelectComponent.prototype._selected;
    /** @type {?} */
    SelectComponent.prototype.touch;
    /** @type {?} */
    SelectComponent.prototype.propagateChange;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/component/multi-select-input/multi-select-input.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * 下拉多選控件，可輸入不存在選單的值
 * 原名: techmore-multiselect
 */
class MultiSelectInputComponent {
    /**
     * @param {?} platformId
     * @param {?} elRef
     */
    constructor(platformId, elRef) {
        this.platformId = platformId;
        this.elRef = elRef;
        /**
         * 篩選後的可選項
         */
        this.filterList = [];
        /**
         * 無篩選值時顯示所有選項，預設為真
         */
        this.showAll = true;
        /**
         * 是否可以新增選項，預設為真
         */
        this.canNewOption = true;
        /**
         * 是否禁用控件
         */
        this.disabled = false;
        /**
         * 預設標籤
         */
        this.placeholder = '請輸入字彙，或從現有字彙中選擇。';
        this.onChange = (/**
         * @param {?} _
         * @return {?}
         */
        (_) => { });
        this.onTouched = (/**
         * @return {?}
         */
        () => { });
        this.isBrowser = isPlatformBrowser(this.platformId);
    }
    /**
     * @param {?} v
     * @return {?}
     */
    set selected(v) {
        this._selected = v;
        this.onChange(this._selected);
        this.triggerDomChangeEvent();
    }
    /**
     * @return {?}
     */
    get selected() { return this._selected; }
    /**
     * @param {?} value
     * @return {?}
     */
    writeValue(value) {
        if (value) {
            this.selected = value;
        }
        else if (this.selected && this.selected.length > 0) {
            this.selected = [];
        }
    }
    /**
     * @param {?} fn
     * @return {?}
     */
    registerOnChange(fn) {
        this.onChange = fn;
    }
    /**
     * @param {?} fn
     * @return {?}
     */
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    /**
     * @param {?} isDisabled
     * @return {?}
     */
    setDisabledState(isDisabled) {
        this.disabled = isDisabled;
    }
    /**
     * 是否已存在可項項
     * @param {?} item
     * @return {?}
     */
    isExistingOption(item) {
        if (this.selected) {
            return this.selected.findIndex((/**
             * @param {?} val
             * @return {?}
             */
            val => val.label === item.label)) !== -1;
        }
        return false;
    }
    /**
     * 篩選可選項
     * @param {?} evt
     * @return {?}
     */
    filterOptions(evt) {
        /** @type {?} */
        const str = this.inputVal.nativeElement.value;
        if (evt.keyCode !== 13) { // 輸入文字
            if (str) {
                this.filterList = this.options.filter((/**
                 * @param {?} cht
                 * @return {?}
                 */
                (cht) => {
                    return cht['label'].indexOf(str) > -1;
                }));
            }
            else {
                this.filterList = this.options;
            }
        }
        else { // 按下 ENTER
            if (!this.isExistingOption(str)) { // 不存在的
                if (typeof str === 'string' && str.trim().length > 0) {
                    if (!this.selected) {
                        if (this.canNewOption) {
                            this.selected = [{ label: str, value: null }];
                        }
                    }
                    else {
                        if (this.canNewOption) {
                            this.selected.push({ label: str, value: null });
                        }
                        this.onChange(this.selected);
                        this.triggerDomChangeEvent();
                    }
                }
                this.inputVal.nativeElement.value = '';
                this.filterList = this.options;
            }
            else {
                return;
            }
        }
    }
    /**
     * 選取可選項
     * @param {?} item
     * @return {?}
     */
    selectItem(item) {
        if (!this.selected) {
            this.selected = [item];
        }
        else {
            /** @type {?} */
            const index = this.selected.findIndex((/**
             * @param {?} val
             * @return {?}
             */
            val => val.label === item.label));
            if (index !== -1) { // 重複選取
                this.selected.splice(index, 1); // 移除
            }
            else {
                this.selected.push(item); // 新增
            }
            this.onChange(this.selected);
            this.triggerDomChangeEvent();
        }
        this.onTouched();
    }
    /**
     * 輸入框聚焦
     * @return {?}
     */
    onFocus() {
        this.filterList = this.options;
        this.onTouched();
    }
    /**
     * 輸入框失焦
     * @return {?}
     */
    onSearchInputBlur() {
        this.filterList = [];
    }
    /**
     * 移除已選項
     * @param {?} item
     * @return {?}
     */
    remove(item) {
        /** @type {?} */
        const index = this.selected.findIndex((/**
         * @param {?} val
         * @return {?}
         */
        val => val.label === item.label));
        this.selected.splice(index, 1);
        this.onChange(this.selected);
        this.triggerDomChangeEvent();
        this.onTouched();
    }
    /**
     * 點選日期後要手動觸發原生change事件
     * @return {?}
     */
    triggerDomChangeEvent() {
        if (this.isBrowser) {
            /** @type {?} */
            let event;
            if (typeof (Event) === 'function') {
                event = new Event('change', { bubbles: true, cancelable: true });
            }
            else {
                event = document.createEvent('Event');
                event.initEvent('change', true, true);
            }
            this.elRef.nativeElement.dispatchEvent(event);
        }
    }
}
MultiSelectInputComponent.decorators = [
    { type: Component, args: [{
                selector: 'tm-multiselect',
                template: "<div class=\"txtsearch\" [class.deny]=\"disabled\">\r\n  <div class=\"txt-ctrl\">\r\n    <div class=\"txt-select-item\" *ngFor=\"let item of selected\">{{ item.label }}\r\n      <button class=\"removebtn\" type=\"button\" (click)=\"remove(item)\">X</button>\r\n    </div>\r\n    <input type=\"txt\" [placeholder]=\"placeholder\" class=\"form-control txt-inputexpend\" [disabled]=\"disabled\" [id]=\"name\"\r\n           (keyup)=filterOptions($event) (focus)=\"onFocus()\" (blur)=\"onSearchInputBlur()\" #searchInput>\r\n  </div>\r\n  <div class=\"multi-selectbox\" [hidden]=\"!filterList.length\">\r\n    <ul>\r\n      <ng-container *ngFor=\"let opt of filterList\">\r\n        <li class=\"txt-item\" [class.selected]=\"isExistingOption(opt)\" (mousedown)=\"selectItem(opt)\">{{opt.label}}</li>\r\n      </ng-container>\r\n    </ul>\r\n  </div>\r\n</div>\r\n",
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef((/**
                         * @return {?}
                         */
                        () => MultiSelectInputComponent)),
                        multi: true
                    }
                ],
                encapsulation: ViewEncapsulation.None,
                styles: [".txtsearch{position:relative}.multi-selectbox{position:absolute;max-height:35em;top:100%;left:-1px;right:-1px;border:1px solid #d7d7d7;overflow-x:hidden;overflow-y:auto;background:#fff;z-index:10}.multi-selectbox ul{padding:5px}.multi-selectbox .txt-item{font-size:1em;display:block;padding:.5em .71429em;margin:0;cursor:pointer;border-top:1px solid #fff}.multi-selectbox .txt-item.selected,.multi-selectbox .txt-item:hover{background:#999;color:#fff}.txt-ctrl .txt-inputexpend{float:none;padding:.2em .1em;width:100%;font-size:1em;border:1px solid #ccc;outline:0}.txt-select-item{font-size:.8em;position:relative;margin:.2em;padding:.33333em .33333em .33333em 1.5em;float:left;border-radius:.25em;border:1px solid #999;color:#fff;background-color:#999;-webkit-animation:.2s fstAnimationEnter;animation:.2s fstAnimationEnter}.removebtn{margin:-.64286em 0 0;padding:0;border:0;cursor:pointer;background:0 0;font-size:1.16667em;position:absolute;left:0;top:50%;width:1.28571em;line-height:1.28571em;text-align:center;color:#fff}.deny{pointer-events:none}"]
            }] }
];
/** @nocollapse */
MultiSelectInputComponent.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [PLATFORM_ID,] }] },
    { type: ElementRef }
];
MultiSelectInputComponent.propDecorators = {
    inputVal: [{ type: ViewChild, args: ['searchInput', { static: false },] }],
    showAll: [{ type: Input }],
    canNewOption: [{ type: Input }],
    options: [{ type: Input }],
    disabled: [{ type: Input }],
    name: [{ type: Input }],
    placeholder: [{ type: Input }]
};
if (false) {
    /** @type {?} */
    MultiSelectInputComponent.prototype.inputVal;
    /**
     * 篩選後的可選項
     * @type {?}
     */
    MultiSelectInputComponent.prototype.filterList;
    /**
     * 無篩選值時顯示所有選項，預設為真
     * @type {?}
     */
    MultiSelectInputComponent.prototype.showAll;
    /**
     * 是否可以新增選項，預設為真
     * @type {?}
     */
    MultiSelectInputComponent.prototype.canNewOption;
    /**
     * 可選項
     * @type {?}
     */
    MultiSelectInputComponent.prototype.options;
    /**
     * 是否禁用控件
     * @type {?}
     */
    MultiSelectInputComponent.prototype.disabled;
    /**
     * 控件名
     * @type {?}
     */
    MultiSelectInputComponent.prototype.name;
    /**
     * 預設標籤
     * @type {?}
     */
    MultiSelectInputComponent.prototype.placeholder;
    /**
     * 所選項
     * @type {?}
     */
    MultiSelectInputComponent.prototype._selected;
    /**
     * 是否渲染端為瀏覽器
     * @type {?}
     * @protected
     */
    MultiSelectInputComponent.prototype.isBrowser;
    /** @type {?} */
    MultiSelectInputComponent.prototype.onChange;
    /** @type {?} */
    MultiSelectInputComponent.prototype.onTouched;
    /**
     * @type {?}
     * @protected
     */
    MultiSelectInputComponent.prototype.platformId;
    /**
     * @type {?}
     * @protected
     */
    MultiSelectInputComponent.prototype.elRef;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/component/single-select-input/single-select-input.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * 下拉單選控件，可輸入不存在選單的值
 * 原名: techmore-singleselect
 */
class SingleSelectInputComponent {
    /**
     * @param {?} elementRef
     */
    constructor(elementRef) {
        this.elementRef = elementRef;
        /**
         * 篩選後的可選項
         */
        this.filterList = [];
        /**
         * 無篩選值時顯示所有選項，預設為真
         */
        this.showAll = true;
        /**
         * 是否可以新增選項，預設為真
         */
        this.canNewOption = true;
        /**
         * 是否禁用控件
         */
        this.disabled = false;
        /**
         * 預設選擇標籤
         */
        this.placeholder = '請輸入字彙，或從現有字彙中選擇。';
        /**
         * input 輸入框以秀label為主, 否則為 value
         */
        this.inputSet2Label = true;
        /**
         * 允許搜尋時也對選項的value進行比對，預設為假
         */
        this.enableValueSearch = false;
        /**
         * 允許下拉清單中的項目文字也會出現value值，預設為假
         */
        this.enableValueInList = false;
        this.isShowFilterList = false;
        this.onChange = (/**
         * @param {?} _
         * @return {?}
         */
        (_) => { });
        this.onTouched = (/**
         * @param {?} _
         * @return {?}
         */
        (_) => { });
    }
    /**
     * @param {?} v
     * @return {?}
     */
    set selected(v) {
        this._selected = v;
        this.onChange(this._selected);
    }
    /**
     * @return {?}
     */
    get selected() { return this._selected; }
    /**
     * @param {?} value
     * @return {?}
     */
    writeValue(value) {
        if (value) {
            this.selected = value;
            this.makeFilterList(value.label);
        }
        else if (this.selected) {
            this.selected = value;
            this.makeFilterList(null);
        }
    }
    /**
     * @param {?} changes
     * @return {?}
     */
    ngOnChanges(changes) {
        //Called before any other lifecycle hook. Use it to inject dependencies, but avoid any serious work here.
        //Add '${implements OnChanges}' to the class.
        if (changes['options'] && this.options && this.options.length) {
            if (this.selected && this.selected.value) {
                this.makeFilterList(this.selected.label);
            }
            else {
                this.makeFilterList(null);
            }
        }
    }
    /**
     * @param {?} fn
     * @return {?}
     */
    registerOnChange(fn) {
        this.onChange = fn;
    }
    /**
     * @param {?} fn
     * @return {?}
     */
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    /**
     * @param {?} isDisabled
     * @return {?}
     */
    setDisabledState(isDisabled) {
        this.disabled = isDisabled ? true : false;
    }
    /**
     * 是否已存在可項項
     * @param {?} itemLabel
     * @return {?}
     */
    isExistingOption(itemLabel) {
        if (this.selected && this.selected.label === itemLabel) {
            return true;
        }
        else {
            return false;
        }
    }
    /**
     * 篩選可選項
     * @param {?} evt
     * @return {?}
     */
    filterOptions(evt) {
        /** @type {?} */
        const str = this.inputVal.nativeElement.value;
        if (evt.keyCode !== 13) { // 輸入文字
            this.makeFilterList(str);
            if (str) {
                if (this.filterList.length > 0) {
                    this.selected = (typeof this.equivalentPredicate === 'function'
                        ? this.filterList.find(this.equivalentPredicate)
                        : this.filterList.find((/**
                         * @param {?} __0
                         * @return {?}
                         */
                        ({ label }) => label === str))) || this.selected;
                }
                else if (this.selected) {
                    this.selected = undefined;
                }
            }
            else {
                this.selected = undefined;
            }
        }
        else { // 按下 ENTER
            if (!this.isExistingOption(str)) { // 不存在的
                if (this.filterList.length === 1) {
                    this.selected = this.filterList[0];
                }
                else if ((this.filterList.length === 0)) {
                    if (this.canNewOption) {
                        this.selected = { label: str, value: null };
                        this.makeFilterList(null);
                    }
                }
            }
        }
    }
    /**
     * @private
     * @param {?} str
     * @return {?}
     */
    makeFilterList(str) {
        if (str) {
            this.filterList = typeof this.filterPredicate === 'function'
                ? this.options.filter(this.filterPredicate)
                : this.options.filter((/**
                 * @param {?} __0
                 * @return {?}
                 */
                ({ label, value }) => this.enableValueSearch
                    ? label.indexOf(str) > -1 || String(value).indexOf(str) > -1
                    : label.indexOf(str) > -1));
        }
        else {
            this.filterList = this.showAll ? this.options : [];
        }
    }
    /**
     * @return {?}
     */
    onBlur() {
        if (this.selected) {
            if (this.inputVal.nativeElement.value) {
                if (this.selected.label !== this.inputVal.nativeElement.value) {
                    this.inputVal.nativeElement.value = this.inputSet2Label ? this.selected.label : this.selected.value;
                }
            }
        }
        else {
            if (this.inputVal.nativeElement.value) {
                this.inputVal.nativeElement.value = '';
                // this.filterList = [];
            }
        }
    }
    /**
     * 選取可選項
     * @param {?} item
     * @return {?}
     */
    selectItem(item) {
        if (this.selected === item) { // 重複選取
            // this.selected = undefined; // 移除
        }
        else {
            this.selected = item; // 設定
        }
    }
    /**
     * @param {?} evt
     * @return {?}
     */
    handleClick(evt) {
        /** @type {?} */
        const clickedComponent = evt.target;
        /** @type {?} */
        let inside = false;
        if (this.elementRef.nativeElement.contains(clickedComponent)) {
            inside = true;
        }
        this.isShowFilterList = inside && clickedComponent.localName === 'input';
    }
}
SingleSelectInputComponent.decorators = [
    { type: Component, args: [{
                selector: 'tm-singleselect',
                template: "<div class=\"txtsearch\" [class.deny]=\"disabled\">\r\n  <div class=\"txt-ctrl\">\r\n    <input\r\n    [autocomplete]=\"'off'\"\r\n    type=\"text\"\r\n    [id]=\"name\"\r\n    [placeholder]=\"placeholder\"\r\n    class=\"form-control txt-inputexpend\"\r\n    [disabled]=\"disabled\"\r\n    (keyup)=filterOptions($event)\r\n    value=\"{{inputSet2Label ? selected?.label : selected?.value}}\"\r\n    (blur)=\"onBlur()\"\r\n    #searchInput>\r\n  </div>\r\n  <div class=\"multi-selectbox\" [hidden]=\"!filterList.length || !isShowFilterList\">\r\n    <ul>\r\n      <ng-container *ngFor=\"let opt of filterList\">\r\n        <ng-container *ngIf=\"enableValueInList; else labelOnly\">\r\n          <li class=\"txt-item\" [attr.data-value]=\"opt.value\" [class.selected]=\"isExistingOption(opt.label)\"\r\n              (click)=\"selectItem(opt)\">{{opt.value}} - {{opt.label}}\r\n          </li>\r\n        </ng-container>\r\n        <ng-template #labelOnly>\r\n          <li class=\"txt-item\" [attr.data-value]=\"opt.value\" [class.selected]=\"isExistingOption(opt.label)\"\r\n              (click)=\"selectItem(opt)\">{{opt.label}}\r\n          </li>\r\n        </ng-template>\r\n\r\n      </ng-container>\r\n    </ul>\r\n  </div>\r\n</div>\r\n",
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef((/**
                         * @return {?}
                         */
                        () => SingleSelectInputComponent)),
                        multi: true
                    }
                ],
                encapsulation: ViewEncapsulation.None,
                styles: [".txtsearch{position:relative}.multi-selectbox{position:absolute;max-height:35em;top:100%;left:-1px;right:-1px;border:1px solid #d7d7d7;overflow-x:hidden;overflow-y:auto;background:#fff;z-index:10}.multi-selectbox ul{padding:5px}.multi-selectbox .txt-item{font-size:1em;display:block;padding:.5em .71429em;margin:0;cursor:pointer;border-top:1px solid #fff}.multi-selectbox .txt-item.selected,.multi-selectbox .txt-item:hover{background:hsl(230deg,60%,80%);color:#fff}.txt-ctrl .txt-inputexpend{float:none;padding:.2em .1em;width:100%;font-size:1em;border:none;outline:0}.txt-select-item{font-size:.8em;position:relative;margin:.2em;padding:.33333em .33333em .33333em 1.5em;float:left;border-radius:.25em;border:1px solid;color:#fff;background-color:hsl(230deg,60%,80%);-webkit-animation:.2s fstAnimationEnter;animation:.2s fstAnimationEnter}.removebtn{margin:-.64286em 0 0;padding:0;border:0;cursor:pointer;background:0 0;font-size:1.16667em;position:absolute;left:0;top:50%;width:1.28571em;line-height:1.28571em;text-align:center;color:#fff}.deny{pointer-events:none}"]
            }] }
];
/** @nocollapse */
SingleSelectInputComponent.ctorParameters = () => [
    { type: ElementRef }
];
SingleSelectInputComponent.propDecorators = {
    inputVal: [{ type: ViewChild, args: ['searchInput', { static: false },] }],
    showAll: [{ type: Input }],
    canNewOption: [{ type: Input }],
    options: [{ type: Input }],
    disabled: [{ type: Input }],
    name: [{ type: Input }],
    placeholder: [{ type: Input }],
    inputSet2Label: [{ type: Input }],
    enableValueSearch: [{ type: Input }],
    enableValueInList: [{ type: Input }],
    filterPredicate: [{ type: Input }],
    equivalentPredicate: [{ type: Input }],
    handleClick: [{ type: HostListener, args: ['document:click', ['$event'],] }]
};
if (false) {
    /** @type {?} */
    SingleSelectInputComponent.prototype.inputVal;
    /**
     * 篩選後的可選項
     * @type {?}
     */
    SingleSelectInputComponent.prototype.filterList;
    /**
     * 無篩選值時顯示所有選項，預設為真
     * @type {?}
     */
    SingleSelectInputComponent.prototype.showAll;
    /**
     * 是否可以新增選項，預設為真
     * @type {?}
     */
    SingleSelectInputComponent.prototype.canNewOption;
    /**
     * 可選項
     * @type {?}
     */
    SingleSelectInputComponent.prototype.options;
    /**
     * 是否禁用控件
     * @type {?}
     */
    SingleSelectInputComponent.prototype.disabled;
    /**
     * 控件名
     * @type {?}
     */
    SingleSelectInputComponent.prototype.name;
    /**
     * 預設選擇標籤
     * @type {?}
     */
    SingleSelectInputComponent.prototype.placeholder;
    /**
     * input 輸入框以秀label為主, 否則為 value
     * @type {?}
     */
    SingleSelectInputComponent.prototype.inputSet2Label;
    /**
     * 允許搜尋時也對選項的value進行比對，預設為假
     * @type {?}
     */
    SingleSelectInputComponent.prototype.enableValueSearch;
    /**
     * 允許下拉清單中的項目文字也會出現value值，預設為假
     * @type {?}
     */
    SingleSelectInputComponent.prototype.enableValueInList;
    /**
     * 帶入自定義的清單過濾函式
     * @type {?}
     */
    SingleSelectInputComponent.prototype.filterPredicate;
    /**
     * 帶入自定義的選項相等比較函式
     * @type {?}
     */
    SingleSelectInputComponent.prototype.equivalentPredicate;
    /** @type {?} */
    SingleSelectInputComponent.prototype.isShowFilterList;
    /**
     * 所選項
     * @type {?}
     */
    SingleSelectInputComponent.prototype._selected;
    /** @type {?} */
    SingleSelectInputComponent.prototype.onChange;
    /** @type {?} */
    SingleSelectInputComponent.prototype.onTouched;
    /**
     * @type {?}
     * @private
     */
    SingleSelectInputComponent.prototype.elementRef;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/component/checkbox-list/checkbox-list.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * 原名 techmore-checkbox
 */
class CheckboxListComponent {
    constructor() {
        this.class = '';
        this.className = '';
        this.disabled = false;
        this.name = '';
        this._checkedItems = new Array();
        this.propagateChange = (/**
         * @param {?} _
         * @return {?}
         */
        (_) => { });
        this.touch = (/**
         * @param {?} _
         * @return {?}
         */
        (_) => { });
    }
    /**
     * @param {?} c
     * @return {?}
     */
    set listClassName(c) {
        this.class = c || '';
    }
    /**
     * @param {?} value
     * @return {?}
     */
    set checkedItems(value) {
        this._checkedItems = value;
        this.propagateChange(value);
    }
    /**
     * @return {?}
     */
    get checkedItems() { return this._checkedItems; }
    /**
     * @param {?} obj
     * @return {?}
     */
    writeValue(obj) {
        if (obj) {
            this.checkedItems = obj;
        }
        else {
            this.checkedItems = new Array();
        }
    }
    /**
     * @param {?} fn
     * @return {?}
     */
    registerOnChange(fn) {
        this.propagateChange = fn;
    }
    /**
     * @param {?} fn
     * @return {?}
     */
    registerOnTouched(fn) {
        this.touch = fn;
    }
    /**
     * @param {?} isDisabled
     * @return {?}
     */
    setDisabledState(isDisabled) {
        this.disabled = isDisabled ? true : false;
    }
    /**
     * @param {?} value
     * @return {?}
     */
    isChecked(value) {
        if (from(this.checkedItems)
            .where((/**
         * @param {?} item
         * @return {?}
         */
        item => item === +value))
            .select((/**
         * @param {?} item
         * @return {?}
         */
        item => item))
            .defaultIfEmpty(null)
            .first()) {
            return true;
        }
        else {
            return false;
        }
    }
    /**
     * @param {?} checked
     * @param {?} value
     * @return {?}
     */
    onItemChange(checked, value) {
        if (checked) {
            this.checkedItems.push(+value);
        }
        else {
            this.checkedItems.forEach((/**
             * @param {?} item
             * @param {?} index
             * @param {?} arr
             * @return {?}
             */
            function (item, index, arr) {
                if (item === +value) {
                    arr.splice(index, 1);
                }
            }));
        }
        this.propagateChange(this.checkedItems);
    }
}
CheckboxListComponent.decorators = [
    { type: Component, args: [{
                selector: 'tm-checkbox-list',
                template: "<ng-container *ngFor=\"let option of options; let i = index\">\r\n  <tm-checkbox  [index]=\"i\"\r\n                [name]=\"name + 'ck' + i\"\r\n                [value]=\"option.value\"\r\n                [isChecked]=\"isChecked(option.data)\"\r\n                (change)=\"onItemChange(item.isChecked, option.data)\"\r\n                [disabled]=\"disabled || (maxLen && (checkedItems.length >= maxLen && !item.isChecked))\"\r\n                [className]=\"className\"\r\n                [itemClassName]=\"itemClassName\"\r\n                [label]=\"option.label\" #item=\"Checkbox\"\r\n                [template]=\"checkboxTemplate\"\r\n                ></tm-checkbox>\r\n</ng-container>\r\n",
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef((/**
                         * @return {?}
                         */
                        () => CheckboxListComponent)),
                        multi: true
                    }
                ],
                encapsulation: ViewEncapsulation.None,
                styles: [""]
            }] }
];
CheckboxListComponent.propDecorators = {
    class: [{ type: HostBinding, args: ['class',] }],
    listClassName: [{ type: Input }],
    itemClassName: [{ type: Input }],
    className: [{ type: Input }],
    disabled: [{ type: Input }],
    options: [{ type: Input }],
    name: [{ type: Input }],
    maxLen: [{ type: Input }],
    checkboxTemplate: [{ type: Input }]
};
if (false) {
    /** @type {?} */
    CheckboxListComponent.prototype.class;
    /** @type {?} */
    CheckboxListComponent.prototype.itemClassName;
    /** @type {?} */
    CheckboxListComponent.prototype.className;
    /** @type {?} */
    CheckboxListComponent.prototype.disabled;
    /** @type {?} */
    CheckboxListComponent.prototype.options;
    /** @type {?} */
    CheckboxListComponent.prototype.name;
    /**
     * 最大可勾選數量
     * @type {?}
     */
    CheckboxListComponent.prototype.maxLen;
    /** @type {?} */
    CheckboxListComponent.prototype.checkboxTemplate;
    /** @type {?} */
    CheckboxListComponent.prototype._checkedItems;
    /** @type {?} */
    CheckboxListComponent.prototype.propagateChange;
    /** @type {?} */
    CheckboxListComponent.prototype.touch;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/component/checkbox/checkbox.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class CheckboxComponent {
    constructor() {
        this.class = '';
        this.name = '';
        this.isChecked = undefined;
        this.className = '';
        this.label = '';
        this.propagateChange = (/**
         * @param {?} _
         * @return {?}
         */
        (_) => { });
        this.touch = (/**
         * @param {?} _
         * @return {?}
         */
        (_) => { });
        this.onChange = (/**
         * @param {?} $event
         * @return {?}
         */
        ($event) => {
            this.isChecked = $event.target.checked || undefined;
            this.propagateChange(this.isChecked);
        });
    }
    /**
     * @param {?} changes
     * @return {?}
     */
    ngOnChanges(changes) {
        if (!isNullOrUndefined(this.itemClassName) && !isNullOrUndefined(this.index)) {
            if (typeof this.itemClassName === 'string') {
                this.class = this.itemClassName;
            }
            else if (typeof this.itemClassName === 'function') {
                this.class = this.itemClassName(this.index);
            }
            else {
                this.class = '';
            }
        }
    }
    /**
     * @param {?} obj
     * @return {?}
     */
    writeValue(obj) {
        if (obj) {
            this.isChecked = obj;
            this.propagateChange(obj);
        }
        else if (this.isChecked) {
            this.isChecked = undefined;
            this.propagateChange(undefined);
        }
    }
    /**
     * @param {?} fn
     * @return {?}
     */
    registerOnChange(fn) {
        this.propagateChange = fn;
    }
    /**
     * @param {?} fn
     * @return {?}
     */
    registerOnTouched(fn) {
        this.touch = fn;
    }
    /**
     * @param {?} isDisabled
     * @return {?}
     */
    setDisabledState(isDisabled) {
        this.disabled = isDisabled ? true : false;
    }
}
CheckboxComponent.decorators = [
    { type: Component, args: [{
                selector: 'tm-checkbox',
                template: "<ng-container *ngTemplateOutlet=\"template || defaultTmp; context: {\r\n  $implicit: value,\r\n  label: label,\r\n  name: name,\r\n  index: index,\r\n  isChecked: isChecked,\r\n  disabled: disabled,\r\n  className: className,\r\n  fn: {\r\n    onChange: this.onChange\r\n  }\r\n}\"></ng-container>\r\n\r\n<ng-template #defaultTmp let-name=\"name\" let-index=\"index\" let-value let-label=\"label\" let-isChecked=\"isChecked\" let-disabled=\"disabled\" let-onChange=\"fn.onChange\" let-className=\"className\">\r\n  <div class=\"{{ className? className:'' }}\">\r\n    <input  type=\"checkbox\" name=\"{{ name }}\" id=\"{{ name }}\"\r\n            [value]=\"value\"\r\n            [checked]=\"isChecked\"\r\n            [disabled]=\"disabled\"\r\n            (change)=\"onChange($event)\"\r\n            #item>\r\n    <label for=\"{{ name }}\">{{ label }}</label>\r\n  </div>\r\n</ng-template>",
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef((/**
                         * @return {?}
                         */
                        () => CheckboxComponent)),
                        multi: true
                    }
                ],
                exportAs: 'Checkbox',
                encapsulation: ViewEncapsulation.None,
                styles: [""]
            }] }
];
CheckboxComponent.propDecorators = {
    class: [{ type: HostBinding, args: ['class',] }],
    itemClassName: [{ type: Input }],
    name: [{ type: Input }],
    index: [{ type: Input }],
    value: [{ type: Input }],
    isChecked: [{ type: Input }],
    disabled: [{ type: Input }],
    className: [{ type: Input }],
    label: [{ type: Input }],
    template: [{ type: Input }]
};
if (false) {
    /** @type {?} */
    CheckboxComponent.prototype.class;
    /** @type {?} */
    CheckboxComponent.prototype.itemClassName;
    /** @type {?} */
    CheckboxComponent.prototype.name;
    /** @type {?} */
    CheckboxComponent.prototype.index;
    /** @type {?} */
    CheckboxComponent.prototype.value;
    /** @type {?} */
    CheckboxComponent.prototype.isChecked;
    /** @type {?} */
    CheckboxComponent.prototype.disabled;
    /** @type {?} */
    CheckboxComponent.prototype.className;
    /** @type {?} */
    CheckboxComponent.prototype.label;
    /** @type {?} */
    CheckboxComponent.prototype.template;
    /** @type {?} */
    CheckboxComponent.prototype.propagateChange;
    /** @type {?} */
    CheckboxComponent.prototype.touch;
    /** @type {?} */
    CheckboxComponent.prototype.onChange;
}
/**
 * @param {?} val
 * @return {?}
 */
function isNullOrUndefined(val) {
    return val === null || val === undefined;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/component/multiple-choice/multiple-choice.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * 原名: multiple-choice-select
 */
class MultipleChoiceComponent {
    /**
     * @param {?} el
     */
    constructor(el) {
        this.el = el;
        /**
         * 是否禁用
         */
        this.disabled = false;
        /**
         * 選擇的表單控件號碼，預設 0 為全顯示
         */
        this.selectedDomNo = 0;
        /**
         * 多選一控件值
         */
        this._value = '';
        this.touch = (/**
         * @param {?} _
         * @return {?}
         */
        (_) => { });
        this.changeEventHandler = (/**
         * @param {?} evt
         * @param {?} formCtrlNo
         * @return {?}
         */
        (evt, formCtrlNo) => {
            if (!evt || evt.trim() === '') {
                this.selectedDomNo = 0;
                this.value = '';
            }
            else {
                this.selectedDomNo = formCtrlNo;
                this.value = evt;
            }
        });
    }
    /**
     * 表單控件的映射表 <K:number 控件對應到的號碼，不可為 0，應為 selectedDomNo 的可選集合, V:any 從外部投影入的控件值>
     * @param {?} obj
     * @return {?}
     */
    set formCtrlDataMap(obj) {
        if (obj) {
            Object.keys(obj).map((/**
             * @param {?} k
             * @param {?} index
             * @return {?}
             */
            (k, index) => {
                /** @type {?} */
                const v = obj[k];
                if (v && (typeof v === 'string' && v.trim() !== '')) {
                    if (!this.selectedDomNo) {
                        this.selectedDomNo = +k;
                        this.value = v;
                    }
                }
                else {
                    obj[k] = '';
                }
            }));
            this._formCtrlDataMap = obj;
        }
    }
    /**
     * @param {?} val
     * @return {?}
     */
    set value(val) {
        if (val) {
            this._value = val.toString();
        }
        else {
            this._value = '';
        }
        if (this.propagateChange) {
            this.propagateChange(this._value);
        }
    }
    /**
     * @return {?}
     */
    get value() { return this._value; }
    /**
     * @param {?} obj
     * @return {?}
     */
    writeValue(obj) {
        if (obj) {
            this.value = obj;
        }
        else if (this.propagateChange && this._value) {
            this.propagateChange(this._value);
        }
    }
    /**
     * @param {?} fn
     * @return {?}
     */
    registerOnChange(fn) {
        this.propagateChange = fn;
        if (this._value) {
            this.propagateChange(this._value);
        }
    }
    /**
     * @param {?} fn
     * @return {?}
     */
    registerOnTouched(fn) {
        this.touch = fn;
    }
    /**
     * @param {?} isDisabled
     * @return {?}
     */
    setDisabledState(isDisabled) {
        this.disabled = isDisabled ? true : false;
    }
}
MultipleChoiceComponent.decorators = [
    { type: Component, args: [{
                selector: 'tm-multiple-choice',
                template: "<ng-container *ngTemplateOutlet=\"template; context: {\r\n  name: this.name,\r\n  showDomNo: this.selectedDomNo,\r\n  disabled: this.disabled,\r\n  value: this.value,\r\n  fns: { onChange: this.changeEventHandler, onTouch: this.touch }\r\n}\"></ng-container>\r\n",
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef((/**
                         * @return {?}
                         */
                        () => MultipleChoiceComponent)),
                        multi: true
                    }
                ]
            }] }
];
/** @nocollapse */
MultipleChoiceComponent.ctorParameters = () => [
    { type: ElementRef }
];
MultipleChoiceComponent.propDecorators = {
    disabled: [{ type: Input }],
    name: [{ type: Input }],
    formCtrlDataMap: [{ type: Input }],
    template: [{ type: ContentChild, args: [TemplateRef, { static: false },] }]
};
if (false) {
    /**
     * 是否禁用
     * @type {?}
     */
    MultipleChoiceComponent.prototype.disabled;
    /**
     * 表單控制項名稱
     * @type {?}
     */
    MultipleChoiceComponent.prototype.name;
    /**
     * 選擇的表單控件號碼，預設 0 為全顯示
     * @type {?}
     */
    MultipleChoiceComponent.prototype.selectedDomNo;
    /** @type {?} */
    MultipleChoiceComponent.prototype._formCtrlDataMap;
    /**
     * 多選一控件值
     * @type {?}
     */
    MultipleChoiceComponent.prototype._value;
    /**
     * 從外部投影進來的模板
     * @type {?}
     */
    MultipleChoiceComponent.prototype.template;
    /** @type {?} */
    MultipleChoiceComponent.prototype.propagateChange;
    /** @type {?} */
    MultipleChoiceComponent.prototype.touch;
    /** @type {?} */
    MultipleChoiceComponent.prototype.changeEventHandler;
    /**
     * @type {?}
     * @private
     */
    MultipleChoiceComponent.prototype.el;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/directive/allowing-text-count.directive.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * 剩下可輸入的字數
 * 原名: textCount
 */
class AllowingTextCountDirective {
    /**
     * @param {?} platformId
     * @param {?} el
     * @param {?} renderer
     * @param {?} ngModel
     */
    constructor(platformId, el, renderer, ngModel) {
        this.platformId = platformId;
        this.el = el;
        this.renderer = renderer;
        this.ngModel = ngModel;
        this.autoExpandHeight = true;
        this.isBrowser = isPlatformBrowser(this.platformId);
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        if (this.isBrowser) {
            if (!this.countArea) {
                /** @type {?} */
                const _span = this.renderer.createElement("span");
                // 剩餘字數的字
                /** @type {?} */
                const root = this.el.nativeElement.parentElement;
                this.countArea = _span;
                this.renderer.appendChild(root, _span);
            }
            this.orginalHeight = this.el.nativeElement.scrollHeight;
            this.total = 0;
            this.maxCount = this.el.nativeElement.maxLength;
            this.ngModel.valueChanges.subscribe((/**
             * @return {?}
             */
            () => {
                this.countArea.innerText = `${this.maxCount - this.el.nativeElement.value.length}`;
                /** @type {?} */
                const match = JSON.stringify(this.el.nativeElement.value).match(/(?:\\[rn]|[\r\n])/g);
                if (this.autoExpandHeight && match) {
                    this.total = match.length;
                    this.total = this.total * 16; // 給予空白 16px大小
                    this.el.nativeElement.style.height =
                        this.orginalHeight / 1.5 + this.total + "px"; // 根據空白數量給予欄位高度
                }
            }));
        }
    }
    /**
     * @param {?} evt
     * @return {?}
     */
    onKeypress(evt) {
        this.countArea.innerText = `${this.maxCount - evt.currentTarget.value.length}`;
        // this.dynamicGroup(evt.currentTarget);
    }
}
AllowingTextCountDirective.decorators = [
    { type: Directive, args: [{
                selector: '[tmAllowingTextCount]'
            },] }
];
/** @nocollapse */
AllowingTextCountDirective.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [PLATFORM_ID,] }] },
    { type: ElementRef },
    { type: Renderer2 },
    { type: NgModel, decorators: [{ type: Host }] }
];
AllowingTextCountDirective.propDecorators = {
    countArea: [{ type: Input, args: ["textCount",] }],
    autoExpandHeight: [{ type: Input }],
    onKeypress: [{ type: HostListener, args: ["keyup", ["$event"],] }]
};
if (false) {
    /** @type {?} */
    AllowingTextCountDirective.prototype.countArea;
    /** @type {?} */
    AllowingTextCountDirective.prototype.autoExpandHeight;
    /** @type {?} */
    AllowingTextCountDirective.prototype.maxCount;
    /** @type {?} */
    AllowingTextCountDirective.prototype.orginalHeight;
    /** @type {?} */
    AllowingTextCountDirective.prototype.total;
    /**
     * 是否渲染端為瀏覽器
     * @type {?}
     * @protected
     */
    AllowingTextCountDirective.prototype.isBrowser;
    /**
     * @type {?}
     * @protected
     */
    AllowingTextCountDirective.prototype.platformId;
    /**
     * @type {?}
     * @protected
     */
    AllowingTextCountDirective.prototype.el;
    /**
     * @type {?}
     * @protected
     */
    AllowingTextCountDirective.prototype.renderer;
    /**
     * @type {?}
     * @protected
     */
    AllowingTextCountDirective.prototype.ngModel;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/directive/auto-draft-save.directive.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * 原名: techmore-auto-draft-save
 */
class AutoDraftSaveDirective {
    /**
     * @param {?} platformId
     * @param {?} ngForm
     */
    constructor(platformId, ngForm) {
        this.platformId = platformId;
        this.ngForm = ngForm;
        this.enableAutoDraftSave = true;
        this.autoDraftSave = new EventEmitter();
        this.saveDebounceTime = 600000;
        this.isBrowser = isPlatformBrowser(this.platformId);
    }
    /**
     * @return {?}
     */
    ngAfterViewInit() {
        if (this.isBrowser) {
            this.formSubscription = this.ngForm.valueChanges.pipe(debounceTime(this.saveDebounceTime), filter((/**
             * @param {?} data
             * @return {?}
             */
            (data) => this.enableAutoDraftSave)), distinctUntilChanged((/**
             * @param {?} x
             * @param {?} y
             * @return {?}
             */
            (x, y) => JSON.stringify(x) === JSON.stringify(y))))
                .subscribe((/**
             * @param {?} data
             * @return {?}
             */
            (data) => {
                this.autoDraftSave.emit(data);
            }));
        }
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        if (this.formSubscription) {
            this.formSubscription.unsubscribe();
        }
    }
}
AutoDraftSaveDirective.decorators = [
    { type: Directive, args: [{
                selector: '[tmAutoDraftSave]'
            },] }
];
/** @nocollapse */
AutoDraftSaveDirective.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [PLATFORM_ID,] }] },
    { type: NgForm }
];
AutoDraftSaveDirective.propDecorators = {
    enableAutoDraftSave: [{ type: Input, args: ['tmAutoDraftSave',] }],
    autoDraftSave: [{ type: Output }],
    saveDebounceTime: [{ type: Input }]
};
if (false) {
    /** @type {?} */
    AutoDraftSaveDirective.prototype.formSubscription;
    /** @type {?} */
    AutoDraftSaveDirective.prototype.enableAutoDraftSave;
    /** @type {?} */
    AutoDraftSaveDirective.prototype.autoDraftSave;
    /** @type {?} */
    AutoDraftSaveDirective.prototype.saveDebounceTime;
    /**
     * 是否渲染端為瀏覽器
     * @type {?}
     * @protected
     */
    AutoDraftSaveDirective.prototype.isBrowser;
    /**
     * @type {?}
     * @protected
     */
    AutoDraftSaveDirective.prototype.platformId;
    /**
     * @type {?}
     * @private
     */
    AutoDraftSaveDirective.prototype.ngForm;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/pipe/map-label.pipe.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * 將選項的值轉成標籤名稱，可接受單個選項值或是選項值的陣列
 */
class MapLabelPipe {
    /**
     * @param {?} value
     * @param {?} options
     * @return {?}
     */
    transform(value, options) {
        if (Array.isArray(value)) {
            return mapValsToLabel(value, options);
        }
        else {
            return mapValToLabel(value, options);
        }
    }
}
MapLabelPipe.decorators = [
    { type: Pipe, args: [{
                name: 'mapLabel'
            },] }
];
/**
 * 將選項的值轉成標籤名稱
 * @param {?} value 選項值
 * @param {?} options 選項
 * @return {?} 選項標籤
 */
function mapValToLabel(value, options) {
    /** @type {?} */
    let find = options.find((/**
     * @param {?} opt
     * @return {?}
     */
    opt => opt.value === value));
    if (find) {
        return find.label;
    }
    return value;
}
/**
 * 將多個選項的值轉成標籤名稱們
 * @param {?} value 選項值
 * @param {?} options 選項
 * @return {?} 選項標籤陣列
 */
function mapValsToLabel(value, options) {
    return value.map((/**
     * @param {?} v
     * @return {?}
     */
    v => {
        return mapValToLabel(v, options);
    }));
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/techmore-form.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class TechmoreFormModule {
}
TechmoreFormModule.decorators = [
    { type: NgModule, args: [{
                imports: [
                    CommonModule,
                    FormsModule
                ],
                declarations: [
                    SelectComponent,
                    AllowingTextCountDirective,
                    MultiSelectInputComponent,
                    SingleSelectInputComponent,
                    CheckboxListComponent,
                    MultipleChoiceComponent,
                    CheckboxComponent,
                    AutoDraftSaveDirective,
                    MapLabelPipe,
                ],
                exports: [
                    SelectComponent,
                    AllowingTextCountDirective,
                    MultiSelectInputComponent,
                    SingleSelectInputComponent,
                    CheckboxListComponent,
                    CheckboxComponent,
                    MultipleChoiceComponent,
                    AutoDraftSaveDirective,
                    MapLabelPipe,
                ],
            },] }
];

/**
 * @fileoverview added by tsickle
 * Generated from: lib/entity/select-option.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class SelectOption {
}
if (false) {
    /** @type {?} */
    SelectOption.prototype.label;
    /** @type {?} */
    SelectOption.prototype.value;
    /** @type {?} */
    SelectOption.prototype.data;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/entity/check-item.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class CheckItem extends SelectOption {
    constructor() {
        super(...arguments);
        this.checked = false;
    }
}
if (false) {
    /** @type {?} */
    CheckItem.prototype.checked;
}

/**
 * @fileoverview added by tsickle
 * Generated from: public-api.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: techmore-form.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { AllowingTextCountDirective, CheckItem, CheckboxComponent, CheckboxListComponent, MapLabelPipe, MultiSelectInputComponent, MultipleChoiceComponent, SelectComponent, SelectOption, SingleSelectInputComponent, TechmoreFormModule, mapValToLabel, mapValsToLabel, AutoDraftSaveDirective as ɵa };
//# sourceMappingURL=techmore-form.js.map
